interface StarRatingProps {
  rating: number;
  size?: string;
  showValue?: boolean;
  className?: string;
}

export default function StarRating({
  rating,
  size = "text-sm",
  showValue = false,
  className = "",
}: StarRatingProps) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {stars.map((s) => {
        const fill = Math.min(1, Math.max(0, rating - (s - 1)));
        return (
          <span
            key={s}
            className={`relative inline-block leading-none ${size} text-background-600`}
            aria-hidden="true"
          >
            <i className="ri-star-line"></i>
            <span
              className="absolute inset-0 overflow-hidden whitespace-nowrap"
              style={{ width: `${fill * 100}%` }}
            >
              <i className="ri-star-fill text-accent-500"></i>
            </span>
          </span>
        );
      })}
      {showValue && (
        <span className="ml-1.5 font-label text-xs text-foreground-400">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}